
import * as z from "zod";

export const newUserSchema = z.object({
  first_name: z.string().min(2, "First name must be at least 2 characters"),
  last_name: z.string().min(2, "Last name must be at least 2 characters"),
  email: z.string().email("Please enter a valid email address"),
  password: z.string().min(6, "Password must be at least 6 characters"),
  role: z.enum(["admin", "organization", "public", "administrator", "organization_user"]),
  organization_id: z.string().optional().nullable(),
  is_active: z.boolean().default(true),
});

export const updateUserSchema = z.object({
  first_name: z.string().min(2, "First name must be at least 2 characters"),
  last_name: z.string().min(2, "Last name must be at least 2 characters"),
  email: z.string().email("Please enter a valid email address").optional(),
  role: z.enum(["admin", "organization", "public", "administrator", "organization_user"]),
  organization_id: z.string().optional().nullable(),
  is_active: z.boolean().default(true),
});

export type NewUserFormValues = z.infer<typeof newUserSchema>;
export type UpdateUserFormValues = z.infer<typeof updateUserSchema>;
